import Schedule from './Schedule.vue';

export default Schedule;



// WEBPACK FOOTER //
// ./src/components/parts/catalog/card/components/tabs/schedule/index.ts